<small class="flex flex-column text-center p-2">
  <span>© DIGITAL PAYROLL SERVICES</span>
  <span>Paula Marckxstraat 1, 9051 Gent, België</span>
  <span>BE0806.902.319, VL.: VG.1568/BUC, WAL: W.DISP.1296, BXL: 00143-406-20171109</span>
  <span [innerHTML]="'GENERAL.DPS_POLICIES' | translate"></span>
</small>
